/**
 * The address this app was STARTED on (SPEC-019 D-7).
 *
 * Not the address it is on now, which is what `useLocation` answers and what the
 * arrival band originally asked. The two are the same only until the first
 * navigation, and the difference between them is the whole question the band
 * exists to answer: somebody who FOLLOWED A LINK to a plant is a newcomer to be
 * welcomed, and somebody who walked from the landing screen to the same plant
 * thirty seconds later has already been told what this is.
 *
 * Recorded from `bootstrap.js` rather than at module scope, because "when this
 * module was first imported" is not a fact anybody controls: it is whenever
 * something in the import graph reached it, which route splitting could quietly
 * change without touching this file. The composition root runs once, before
 * React mounts, and knows it.
 */

let entryPath = '';

export function rememberEntryRoute(pathname) {
    entryPath = String(pathname ?? '');
}

export function entryRoutePath() {
    return entryPath;
}
